import {store} from './../../redux/';
import { call, put } from 'redux-saga/effects';
import { url } from './../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';

const getTruckAPI = () => {
    return APICallingService.sendRequestForGet(url.getTrucks, (res) => {

    }, true);
}

function* getTruck() {
    try {
        let s = store.getState();
        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getTruckAPI);
        if (response && response?.callBackStatus?.toLowerCase() == 'success') {
            let responseTruckData = response?.data;
            yield put({
                type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.GET_TRUCK_API_SUCCESS, payload: { value: responseTruckData }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get truck')
                yield put({ type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.GET_TRUCK_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.GET_TRUCK_API_SUCCESS, payload: { value: 'Failed' } });
    }


}

const createTruckAPI = (value) => {

    let payload = {
        "bt_id": value.bt_id,
        "type": value.type,
        "division_id": value.division_id,
        "is_active": true
    }

    return APICallingService.sendRequestForPostWithAuth(url.addTruck, payload, false, (res) => {

    }, true);

}

function* createTruck(action) {

    try {


        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(createTruckAPI, action.payload.value);

        if (response && response?.callBackStatus.toLowerCase() == 'success') {

            alert('Truck no ' + response.data.truck_id + " Added Successfully")


            yield put({
                type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.GET_TRUCK_MANAGEMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.ADD_TRUCK_MANAGEMENT_API_CALL_SUCCESS, payload: { value: response?.callBackStatus }
            })

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to create truck');
                yield put({ type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.ADD_TRUCK_MANAGEMENT_API_CALL_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }


    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.ADD_TRUCK_MANAGEMENT_API_CALL_SUCCESS, payload: { value: 'Failed' } });

    }


}


const editTruckAPI = (value) => {

    let urlEdit = url.editTruck + value.truck_id;

    let payload = {
        "bt_id": value.bt_id,
        "type": value.type,
        "division_id": value.division_id,
        "is_active": value.is_active
    }

    return APICallingService.sendRequestForPut(payload, urlEdit, (res) => {
    }, true);

}

function* editTruck(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(editTruckAPI, action.payload.value);

        if (response && response != null) {


            if (!action.payload.value?.is_active) {
                alert('Truck no ' + response.data.truck_id + " Deleted Successfully")
            }
            else {
                alert('Truck no ' + response.data.truck_id + " Updated Successfully")
            }
            yield put({
                type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.GET_TRUCK_MANAGEMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.EDIT_TRUCK_API_SUCCESS, payload: { value: response?.callBackStatus }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to  update truck ');
                yield put({ type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.EDIT_TRUCK_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }


    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_TRUCK_MANAGEMENT.EDIT_TRUCK_API_SUCCESS, payload: { value: 'Failed' } });

    }


}

export { editTruck, createTruck, getTruck };
